import {ReactElement} from 'react';
import {Box, SxProps, Theme} from '@mui/material';

type Props = {
  src: string;
  alt: string;
  height?: number;
  sx?: SxProps<Theme>;
};

export default function Flag({src, alt, height = 16, sx}: Props): ReactElement {
  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{height, width: 'auto', borderRadius: '2px', display: 'block', ...sx}}
    />
  );
}
